import { VersionData } from "../types"
export const getPlaceholder = (versionData: VersionData[])=>{
    const Android = versionData?.find((i)=>i.osVersion==="Android")
    const iOS = versionData?.find((i)=>i.osVersion==="iOS")
    return {
        number: Android?.appVersion,
        iOS: iOS?.appStore,
        Android: Android?.appStore 
    }
}